import React from 'react';
import HeroBanner from './HeroBanner';
import AboutUsSection from './AboutUsSection';
import OurMission from './OurMission';
import WhyChooseUs from './WhyChooseUs';
import OurProjects from './OurProjects';
import Testimonials from './Testimonials';
import ContactUs from './ContactUs';

const AboutUs: React.FC = () => {
    return (
        <>
            <HeroBanner />
            <AboutUsSection />
            {/* <AboutUsSection /> */}
            {/* <OurMission /> */}
            {/* <WhyChooseUs /> */}
            {/* <Testimonials /> */}
            {/* <ContactUs /> */}
        </>
    );
};

export default AboutUs;